import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { newSummaryTabs } from '../../../routes/sales';

const CollectionSummaryView = () => {
  const tabs = newSummaryTabs();
  return <FingoPaper tabs={tabs} />;
};

export default CollectionSummaryView;
